import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-sky-300/10 bg-[#081738]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <span className="inline-flex items-center rounded-xl bg-white px-3 py-1.5 mb-6">
            <img src={LOGO_URL} alt="CompCar Motors" className="h-10 w-auto" />
          </span>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
            A reliable car today. A clear ownership plan for tomorrow. Rentals,
            rent-to-own and sales from Boksburg, East Rand — with a visible
            price, a defined term and no hidden balloon.
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-sky-300 font-bold mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-vehicles" to="/vehicles" className="text-slate-300 hover:text-[#F57C00] transition-colors">Vehicles</Link></li>
            <li><Link data-testid="footer-link-prequalify" to="/pre-qualify" className="text-slate-300 hover:text-[#F57C00] transition-colors">Pre-Qualify</Link></li>
            <li><Link data-testid="footer-link-apply" to="/apply" className="text-slate-300 hover:text-[#F57C00] transition-colors">Rent-to-Own Application</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-300 hover:text-[#F57C00] transition-colors">Contact</Link></li>
            <li><Link data-testid="footer-link-faq" to="/faq" className="text-slate-300 hover:text-[#F57C00] transition-colors">FAQ</Link></li>
            <li><Link data-testid="footer-link-popia" to="/popia" className="text-slate-300 hover:text-[#F57C00] transition-colors">POPIA Privacy Notice</Link></li>
            <li><Link data-testid="footer-link-portal" to="/portal" className="text-slate-300 hover:text-[#F57C00] transition-colors">Client Portal</Link></li>
            <li><Link data-testid="footer-link-refer" to="/refer-a-friend" className="text-slate-300 hover:text-[#F57C00] transition-colors">Refer a Friend</Link></li>
            <li><Link data-testid="footer-link-rental" to="/rental" className="text-slate-300 hover:text-[#F57C00] transition-colors">Book a Rental</Link></li>
            <li><Link data-testid="footer-link-tradein" to="/trade-in" className="text-slate-300 hover:text-[#F57C00] transition-colors">Trade-In Your Car</Link></li>
            <li><Link data-testid="footer-link-admin" to="/admin" className="text-slate-300 hover:text-[#F57C00] transition-colors">Admin</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-sky-300 font-bold mb-5">Talk to us</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#F57C00]" />
              <a data-testid="footer-phone" href="tel:+27105349926" className="hover:text-white transition-colors">010 534 9926</a>
              <span className="text-slate-600">·</span>
              <a data-testid="footer-phone-alt" href="tel:+27614507416" className="hover:text-white transition-colors">061 450 7416</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#F57C00]" />
              <a data-testid="footer-email" href="mailto:admin@compcarmotors.co.za" className="hover:text-white transition-colors">admin@compcarmotors.co.za</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#F57C00] mt-0.5" />
              <span data-testid="footer-address">Office 10A, 136 North Rand Road,<br />Jansen Park, Boksburg</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
          <p>© 2026 Comprehensive Chain Management (Pty) Ltd t/a CompCar Motors. All rights reserved.</p>
          <p>Approval subject to affordability assessment, verification and vehicle availability. Illustrative pricing only.</p>
        </div>
      </div>
    </footer>
  );
}
